import cn from 'classnames';
import React from 'react';

import styles from './inputs-separator.module.scss';

export const InputsSeparator: React.FC<{ className?: string }> = ({
  className,
}) => {
  return <div className={cn(styles.inputsSeparator, className)}></div>;
};
